export var Status;
(function (Status) {
    Status[Status["Complete"] = 0] = "Complete";
    Status[Status["Incomplete"] = 1] = "Incomplete";
    Status[Status["Issue"] = 2] = "Issue";
})(Status || (Status = {}));
